import {ESnackbarType} from '@entities/ui/snackbar';
import {SnackbarService} from '@shared/services/snackbar.service';

export class SnackbarHelper {
  private static SERVICE: SnackbarService | null = null;

  public static init(service: SnackbarService): void {
    this.SERVICE = service;
  }

  public static open(
    message: string,
    type?: ESnackbarType,
    duration?: number
  ): void {
    this.SERVICE?.open(message, type, duration);
  }
}
